module.exports = __webpack_public_path__ + "img/hassle_free.e439f8a5.png";